import ClimbWriter from './ClimbWriter';
import AdminDashboard from './AdminDashboard';
import ClimbWriterInfoPage, { type ClimbWriterInfoPageKind } from './ClimbWriterInfoPage';
import BugReportWidget from './BugReportWidget';

const legalLinks = [
  ['Contact', '/contact'],
  ['Support', '/support'],
  ['Imprint', '/imprint.html'],
  ['Privacy', '/privacy.html'],
  ['Terms', '/terms.html'],
] as const;

function Footer() {
  return <footer className="cw-footer"><span>© {new Date().getFullYear()} ClimbWriter · Free to write</span><nav aria-label="ClimbWriter legal and support"><a href="/pricing.html">Pricing</a>{legalLinks.filter(([label]) => label !== 'Support').map(([label, href]) => <a key={label} href={href}>{label}</a>)}</nav></footer>;
}

export default function App() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  if (path === '/admin') return <AdminDashboard/>;
  const page = path.slice(1) as ClimbWriterInfoPageKind;
  if (['imprint', 'privacy', 'terms'].includes(page)) { window.location.replace(`/${page}.html${window.location.search}${window.location.hash}`); return null; }
  if (['support', 'contact'].includes(page)) return <><ClimbWriterInfoPage page={page} basePath=""/><BugReportWidget/></>;
  return <div className="cf-page-shell"><ClimbWriter/><Footer/><BugReportWidget/></div>;
}
